import "./ProfTest.css";

import { initRealignMixin, initReorderMixin } from "./mixins";
import { useParams, useSearchParams } from "react-router-dom";

import { LOA } from "./main";
import React from "react";
import { api } from "../../api/api";
import { appActions } from "../../store/slices/appSlice";
import { useAppDispatch } from "../../store";
import { useLoaUser } from "../app/lessons/lessonHooks";

export default function ProfTest() {
  const [html, setHtml] = React.useState<string | null>(null);
  const [busy, setBusy] = React.useState<boolean>(false);
  const [status, setStatus] = React.useState<string | null>(null);
  const [email, setEmail] = React.useState<string | null>(null);
  const initRef = React.useRef(false);
  const [searchParams] = useSearchParams();
  const test = searchParams.get("test"); // legacy
  const { recId } = useParams();
  const testId = recId || test;
  const dispatch = useAppDispatch();
  const user = useLoaUser();
  const isAdmin = user?.loaUser?.admin;

  React.useEffect(() => {
    dispatch(appActions.theme("light"));
  }, [dispatch]);

  React.useEffect(() => {
    if (testId)
      api.exam.getExam(testId).then((data) => {
        if (data) {
          setStatus(isAdmin ? "open" : data.status);
          setEmail(data.email);
          setHtml(data.html);
        }
      });
  }, [testId, isAdmin]);

  React.useEffect(() => {
    if (!html || status !== "open" || initRef.current === true) return;

    const { hash } = window.location;
    const element = document.getElementById(hash.replace("#", ""));
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      element.style.border = "2px solid red";
    }

    setTimeout(() => {
      // legacy javascripts
      LOA.init();
      initRealignMixin();
      initReorderMixin();
      initRef.current = true;
    }, 1000);
  }, [html, status, initRef]);

  const save = () => {
    const form = (document.forms as any).testForm as HTMLFormElement;
    const data = new FormData(form);
    const answers = Array.from(data.entries()).reduce<
      Record<string, FormDataEntryValue>
    >((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
    setBusy(true);
    if (!testId) return;
    api.exam
      .save(testId, answers)
      .then((resp) => {
        if (resp.status === "error") {
          return;
        }
        setBusy(false);
      })
      .catch(console.error);
  };

  const submit = () => {
    const form = (document.forms as any).testForm as HTMLFormElement;
    const data = new FormData(form);
    const answers = Array.from(data.entries()).reduce<
      Record<string, FormDataEntryValue>
    >((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});

    setBusy(true);

    if (!testId) return;

    api.exam
      .submit(testId, answers)
      .then((resp) => {
        if (resp.status === "error") {
          setHtml(resp.html);
          setBusy(false);
          return;
        }
        setHtml(resp.html);
        setStatus(resp.status);
        setBusy(false);
      })
      .catch(console.error);
  };

  if (!html)
    return (
      <div className="flex just-center align-center h120">
        Sæki... / Loading...
      </div>
    );

  return (
    <div style={{ backgroundColor: "#eee" }}>
      <div className="container">
        <div className="prof-test">
          <div className="prof-test-container">
            {status === "closed" && (
              <div>
                <div className="center">
                  <img
                    src="/images/LOA-loa-sol-txt-2@2x.png"
                    width="200"
                    alt="Lóa logo"
                  />
                </div>
                <h2 className="center">Stöðupróf / Placement Test</h2>
                <div className="column m100">
                  <p>Þessu prófi fyrir {email} er lokið.</p>
                </div>
                <div className="column m100">
                  <p>This test for {email} is completed.</p>
                </div>
              </div>
            )}
            {status !== "closed" && (
              <div dangerouslySetInnerHTML={{ __html: html }} />
            )}
          </div>

          {status === "open" && (
            <div className="prof-test-footer">
              <div className="grid auto-auto m-auto grid-gap-20">
                <div className="center mb12">
                  <div className="mb8">
                    Ýttu á <u>Vista</u> takkan til að vista prófið.
                  </div>
                  <div>
                    Press the <u>Save</u> button to save the test.
                  </div>
                </div>
                <div className="center mb12">
                  <div className="mb8">
                    Ýttu á <u>Senda</u> takkan til að ljúka prófinu. Takk fyrir!
                  </div>
                  <div>
                    Press the <u>Submit</u> button to finish the test. Thank
                    you!
                  </div>
                </div>
              </div>
              <div className="grid auto-auto m-auto grid-gap-20">
                {!busy && (
                  <>
                    <button
                      className="loa-button loa-button-secondary w100"
                      onClick={save}
                    >
                      Vista / Save
                    </button>
                    <button
                      className="loa-button loa-button-primary w100"
                      onClick={submit}
                    >
                      Senda / Submit
                    </button>
                  </>
                )}
                {busy && (
                  <div className="center w100">
                    Augnablik... / Please wait...
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
